import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import {RootState} from "./types";

import app from './modules/app/index'


Vue.use(Vuex)

const isDebug = process.env.NODE_ENV !== 'production';

Vue.config.devtools = isDebug;

const vuexPersist = new VuexPersistence<RootState>({
    strictMode: isDebug,
    storage: window.localStorage,
})

const store = new Vuex.Store({
    state: {

    } as RootState,
    mutations: {
        RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION,
    },
    actions: {

    },
    modules: {
        app,
    },
    plugins: [
        vuexPersist.plugin,
    ],
})

export default store;
